import {
  saveSystemSettingsFirestore,
  loadSystemSettingsFirestore,
  subscribeSystemSettingsFirestore,
} from "./firebase";
import { StorageService, STORAGE_KEYS } from "../services/storage";
import { FiscalSettings } from "../types/fiscal";

const DEFAULT_COMMISSION_RATE = 4.0; // 4.0%
const DEFAULT_FIXED_FEE = 2.0; // R$ 2,00

export const DEFAULT_PLATFORM_COMMISSION_RATE = 4.0; // 4.0%
export const DEFAULT_COURT_COMMISSION_RATE = 4.0; // 4.0%
export const DEFAULT_TOURNAMENT_COMMISSION_RATE = 4.0; // 4.0%
export const DEFAULT_TICKET_COMMISSION_RATE = 3.0; // 3.0%
export const DEFAULT_DAY_USE_COMMISSION_RATE = 5.0; // 5.0%
export const DEFAULT_ENTRANCE_FEE_AMOUNT = 5.0; // R$ 5,00
export const DEFAULT_ARENA_FINANCIAL_MODEL: "SPLIT" | "FIXED_MONTHLY" | "HYBRID" = "SPLIT";
export const DEFAULT_FIXED_MONTHLY_FEE = 200.0; // R$ 200,00
export const DEFAULT_HYBRID_MONTHLY_FEE = 99.0; // R$ 99,00
export const DEFAULT_OPERATION_ONLY_MONTHLY_FEE = 99.0; // R$ 99,00 (Plano Operação para Arenas sem Quadras)
export const DEFAULT_HYBRID_COMMISSION_RATE = 2.0; // 2.0%
export const MIN_HYBRID_COMMISSION_RATE = 0.5; // Mínimo no HYBRID para impedir descaracterização em FIXED_MONTHLY

export const PLAN_PDV_VENDAS_LOCAIS_ID = "plan_pdv_vendas_locais";

export const DEFAULT_COMMERCIAL_PLANS: import("../types/commercialRules").CommercialPlan[] = [
  // PDV / VENDAS LOCAIS (Plano Inicial do Dono de Arena — Validade inicial 30 dias, sem exigência de quadras, sem modelo de reservas, sem torneios)
  {
    id: PLAN_PDV_VENDAS_LOCAIS_ID,
    name: "PDV / VENDAS LOCAIS",
    financialModel: "PDV_VENDAS_LOCAIS",
    productType: "PDV_VENDAS_LOCAIS",
    minCourts: 0,
    maxCourts: null,
    monthlyFee: 89.90,
    monthlyAmount: 89.90,
    commissionRate: 0,
    trialDays: 30,
    active: true,
    order: 0,
    version: 1,
    createdAt: "2026-01-01T00:00:00.000Z",
    updatedAt: "2026-01-01T00:00:00.000Z",
  },
  // OPERATION_ONLY (Plano Operação — Mensalidade fixa, 0% comissão, sem exigência de quadras)
  {
    id: "plan_operation_only",
    name: "Plano Operação",
    financialModel: "OPERATION_ONLY",
    productType: "OPERATION_ONLY",
    minCourts: 0,
    maxCourts: null,
    monthlyFee: 99,
    commissionRate: 0,
    active: true,
    order: 0,
    version: 1,
    createdAt: "2026-01-01T00:00:00.000Z",
    updatedAt: "2026-01-01T00:00:00.000Z",
  },
  // FIXED_MONTHLY
  { id: "fixed_1_2", name: "Mensalidade 1–2", financialModel: "FIXED_MONTHLY", minCourts: 1, maxCourts: 2, monthlyFee: 200, commissionRate: 0, active: true, order: 1, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  { id: "fixed_3_4", name: "Mensalidade 3–4", financialModel: "FIXED_MONTHLY", minCourts: 3, maxCourts: 4, monthlyFee: 250, commissionRate: 0, active: true, order: 2, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  { id: "fixed_5_6", name: "Mensalidade 5–6", financialModel: "FIXED_MONTHLY", minCourts: 5, maxCourts: 6, monthlyFee: 300, commissionRate: 0, active: true, order: 3, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  { id: "fixed_7_10", name: "Mensalidade 7–10", financialModel: "FIXED_MONTHLY", minCourts: 7, maxCourts: 10, monthlyFee: 400, commissionRate: 0, active: true, order: 4, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  { id: "fixed_11_15", name: "Mensalidade 11–15", financialModel: "FIXED_MONTHLY", minCourts: 11, maxCourts: 15, monthlyFee: 500, commissionRate: 0, active: true, order: 5, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  { id: "fixed_16_open", name: "Mensalidade 16+", financialModel: "FIXED_MONTHLY", minCourts: 16, maxCourts: null, monthlyFee: 600, commissionRate: 0, active: true, order: 6, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  
  // HYBRID
  { id: "hybrid_1_3", name: "Híbrido 1–3", financialModel: "HYBRID", minCourts: 1, maxCourts: 3, monthlyFee: 99, commissionRate: 2, active: true, order: 1, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  { id: "hybrid_4_6", name: "Híbrido 4–6", financialModel: "HYBRID", minCourts: 4, maxCourts: 6, monthlyFee: 149, commissionRate: 2, active: true, order: 2, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  { id: "hybrid_7_10", name: "Híbrido 7–10", financialModel: "HYBRID", minCourts: 7, maxCourts: 10, monthlyFee: 199, commissionRate: 2, active: true, order: 3, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  { id: "hybrid_11_15", name: "Híbrido 11–15", financialModel: "HYBRID", minCourts: 11, maxCourts: 15, monthlyFee: 299, commissionRate: 2, active: true, order: 4, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },
  { id: "hybrid_16_open", name: "Híbrido 16+", financialModel: "HYBRID", minCourts: 16, maxCourts: null, monthlyFee: 399, commissionRate: 2, active: true, order: 5, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" },

  // SPLIT
  { id: "split_1_open", name: "Split Padrão", financialModel: "SPLIT", minCourts: 1, maxCourts: null, monthlyFee: 0, commissionRate: 4, active: true, order: 1, version: 1, createdAt: "2026-01-01T00:00:00.000Z", updatedAt: "2026-01-01T00:00:00.000Z" }
];

export const DEFAULT_MIN_COURT_DEPOSIT_PERCENTAGE = 20; // 20%
export const DEFAULT_PENDING_RESERVATION_TIMEOUT_MINUTES = 5; // 5 minutos
export const ALLOWED_PENDING_RESERVATION_TIMEOUT_OPTIONS = [5, 10, 15, 30, 60] as const;

export interface SystemSettings {
  pixKeyType: "cnpj" | "cpf" | "email" | "phone" | "random";
  masterPixKey: string;
  masterAccountHolder: string;
  masterBankName: string;
  
  // Modos de Ambiente de Pagamento (Produção Real, Sandbox Mercado Pago, Simulação Local)
  paymentEnvironmentMode: "production" | "sandbox" | "simulation";
  mercadoPagoKey: string; // Token de Produção APP_USR-...
  mercadoPagoPublicKey: string; // Chave Pública APP_USR-...
  mercadoPagoSandboxKey: string; // Token Sandbox TEST-...
  
  // Asaas (Metadados e Estado de Configuração — SEM SECRETS NO FRONTEND/STORAGE)
  asaasEnvironment?: "sandbox" | "production";
  asaasSandboxConfigured?: boolean;
  asaasProductionConfigured?: boolean;
  asaasSandboxWebhookConfigured?: boolean;
  asaasProductionWebhookConfigured?: boolean;
  asaasSandboxKeyLast4?: string;
  asaasProductionKeyLast4?: string;
  
  preferredGateway: "asaas" | "mercadopago" | "auto"; // Gateway de Pagamento Preferencial
  
  creditCardEnabled: boolean;
  pixAutoEnabled: boolean;
  
  // Taxas e Porcentagens (Modo 100% Porcentagem)
  platformCommissionRate: number; // Taxa padrão em % (ex: 4.0%)
  operatorCommissionRate?: number; // Taxa do operador da plataforma em % (ex: 0.0%)
  courtCommissionRate: number;    // Taxa para reservas de quadra % (ex: 4.0%)
  tournamentCommissionRate: number; // Taxa da plataforma para inscrições de torneio % (ex: 4.0%)
  tournamentCommissionEnabled?: boolean; // Se a taxa da plataforma para torneios está ativa (Super Admin)
  allowFreeTournaments?: boolean; // Se o Super Admin permite a criação de torneios gratuitos (R$ 0,00)
  ticketCommissionRate: number;     // Taxa para ingressos % (ex: 3.0%)
  dayUseCommissionRate?: number;    // Taxa para Day Use % (independente de ingressos, ex: 5.0%)
  
  platformFixedFee: number; // Default 0.00 (sem taxa fixa)
  allFeesPercentageMode: boolean; // true = 100% Porcentagem sem taxa fixa R$
  feeDeductionMode: "deduct_from_organizer" | "add_to_athlete";
  allowManualPaymentConfirmInTest: boolean; // Permite confirmação manual em modo teste
  whoPaysMpFee: "platform" | "arena"; // "platform" (Plataforma arca com 0,99% do MP) ou "arena" (Dono arca com 0,99% do MP)
  
  // Parâmetros de Gateway e Taxas Desacopladas
  gatewayFeeModel?: "FIXED" | "PERCENTAGE" | "BOTH";
  gatewayFeeFixed?: number;
  gatewayFeePercentage?: number;
  gatewayFeePayer?: "ARENA" | "PLATFORM";
  activeGateway?: "ASAAS" | "MERCADO_PAGO" | "OTHER";
  
  // Modos de Fluxo de Pagamento e Split
  // "hybrid_mp_priority": Híbrido Inteligente (Usa Mercado Pago Split se arena/torneio tiver token; se não tiver, usa Pix Centralizado)
  // "split_mp_only": Exigir Mercado Pago Split NATIVO na conta da arena/torneio
  // "pix_direct_only": Pix Centralizado com Repasse na Conta Master
  courtPaymentMethodMode: "hybrid_mp_priority" | "split_mp_only" | "pix_direct_only" | "monthly_billing";
  tournamentPaymentMethodMode: "hybrid_mp_priority" | "split_mp_only" | "pix_direct_only" | "monthly_billing";
  // Ciclos e Vencimentos Independentes por Modelo Comercial
  monthlyBillingDays: number; // Quantidade de dias do ciclo (padrão 30 dias - legado/compartilhado)
  monthlyBillingPaymentDueDateDays: number; // Dias para vencimento após fechamento (padrão 4 dias - legado/compartilhado)
  fixedMonthlyBillingDays?: number; // Duração do ciclo de cobrança para Mensalidade Fixa (padrão 30 dias)
  fixedMonthlyDueDays?: number; // Prazo de vencimento após fechamento para Mensalidade Fixa (padrão 4 dias)
  hybridBillingDays?: number; // Duração do ciclo de cobrança para Modelo Híbrido (padrão 30 dias)
  hybridDueDays?: number; // Prazo de vencimento após fechamento para Modelo Híbrido (padrão 4 dias)

  // Taxa de Entrada (Controlada EXCLUSIVAMENTE pelo Super Admin)
  entranceFeeEnabled: boolean; // Se a taxa de entrada de R$ é cobrada no checkout
  entranceFeeAmount: number;  // Valor da taxa de entrada em R$ (ex: R$ 5,00)

  // Módulo de Aluguel de Quadras para Torneios (ETAPA 9C-1)
  tournamentCourtRentalCommissionRate: number; // 10, 20, 30, 40, 50, 60, 70, 80, 90, 100
  tournamentCourtRentalCommissionMode: "ADD" | "ABSORB";

  // Modelos Comerciais da Arena (SPLIT, MENSALIDADE FIXA, HÍBRIDO)
  defaultArenaFinancialModel?: "SPLIT" | "FIXED_MONTHLY" | "HYBRID";
  fixedMonthlyFee?: number; // Padrão da mensalidade fixa em R$ (ex: R$ 299,00)
  hybridMonthlyFee?: number; // Padrão da mensalidade do modelo híbrido em R$ (ex: R$ 99,00)
  hybridCommissionRate?: number; // Taxa de comissão reduzida do modelo híbrido % (ex: 2.0%)
  operationOnlyMonthlyFee?: number; // Padrão da mensalidade do Plano Operação em R$ (ex: R$ 99,00)
  
  commercialPlans?: import("../types/commercialRules").CommercialPlan[];

  // Configurações de Reserva e Confirmação de Quadra (Super Admin)
  pendingReservationTimeoutMinutes?: number; // Tempo limite para confirmação do Pix (ex: 30 minutos)
  minCourtDepositPercentage?: number; // Sinal mínimo permitido na plataforma (mínimo 20%)

  // Controle Global de Homologação / Testes Comerciais (Super Admin)
  allowFrequentCommercialChanges?: boolean; // Permite que donos de arena alterem modelos/planos comerciais sem esperar 30 dias
  limitOneModelChangePerMonth?: boolean; // BLOCO 12I: Limite canônico de 1 alteração de modelo comercial por mês (default: true)

  // Arquitetura Fiscal Base (ETAPA 10-1)
  fiscalSettings?: FiscalSettings;

  // [LEGACY COMPATIBILITY — OPCIONAL EM TIPAGEM APENAS]: Permite tipagem sem erros em chamadas legadas
  asaasKey?: string;
  asaasSandboxApiKey?: string;
  asaasProductionApiKey?: string;
  asaasSandboxWebhookToken?: string;
  asaasProductionWebhookToken?: string;
}

export const DEFAULT_FISCAL_SETTINGS: FiscalSettings = {
  fiscalEngineEnabled: false,
  fiscalMode: "off",
  taxBearer: "PLATFORM",
  ibs: {
    enabled: false,
    rate: 0,
    taxableBaseMethod: "gross",
  },
  cbs: {
    enabled: false,
    rate: 0,
    taxableBaseMethod: "gross",
  },
  splitPayment: {
    enabled: false,
    mode: "off",
  },
  taxRuleVersion: "1.0.0",
};

export const ALLOWED_TOURNAMENT_COURT_RENTAL_COMMISSION_RATES = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
export const DEFAULT_TOURNAMENT_COURT_RENTAL_COMMISSION_RATE = 10;
export const DEFAULT_TOURNAMENT_COURT_RENTAL_COMMISSION_MODE: "ADD" | "ABSORB" = "ADD";

export interface TournamentCourtRentalFinancials {
  rentalAmount: number;
  commissionRate: number;
  commissionMode: "ADD" | "ABSORB";
  platformFeeAmount: number;
  arenaNetAmount: number;
  organizerTotalToPay: number;
}

export const DEFAULT_SYSTEM_SETTINGS: SystemSettings = {
  pixKeyType: "cpf",
  masterPixKey: "",
  masterAccountHolder: "RECEPTOR MASTER DA PLATAFORMA",
  masterBankName: "Banco Inter (077)",
  paymentEnvironmentMode: "sandbox",
  mercadoPagoKey: "",
  mercadoPagoPublicKey: "",
  mercadoPagoSandboxKey: "",
  asaasEnvironment: "sandbox",
  asaasSandboxConfigured: false,
  asaasProductionConfigured: false,
  asaasSandboxWebhookConfigured: false,
  asaasProductionWebhookConfigured: false,
  preferredGateway: "asaas",
  creditCardEnabled: true,
  pixAutoEnabled: true,
  platformCommissionRate: 4.0,
  operatorCommissionRate: 0.0,
  courtCommissionRate: 4.0,
  tournamentCommissionRate: 4.0,
  tournamentCommissionEnabled: true,
  allowFreeTournaments: true,
  ticketCommissionRate: 3.0,
  dayUseCommissionRate: 5.0,
  platformFixedFee: 0,
  allFeesPercentageMode: true,
  feeDeductionMode: "deduct_from_organizer",
  allowManualPaymentConfirmInTest: true,
  whoPaysMpFee: "platform",
  gatewayFeeModel: "FIXED",
  gatewayFeeFixed: 0.99,
  gatewayFeePercentage: 0,
  gatewayFeePayer: "PLATFORM",
  courtPaymentMethodMode: "hybrid_mp_priority",
  tournamentPaymentMethodMode: "hybrid_mp_priority",
  monthlyBillingDays: 30,
  monthlyBillingPaymentDueDateDays: 4,
  fixedMonthlyBillingDays: 30,
  fixedMonthlyDueDays: 4,
  hybridBillingDays: 30,
  hybridDueDays: 4,
  entranceFeeEnabled: false,
  entranceFeeAmount: 5.0,
  tournamentCourtRentalCommissionRate: 10,
  tournamentCourtRentalCommissionMode: "ADD",
  defaultArenaFinancialModel: "SPLIT",
  fixedMonthlyFee: 299.0,
  hybridMonthlyFee: 99.0,
  hybridCommissionRate: 2.0,
  operationOnlyMonthlyFee: 99.0,
  pendingReservationTimeoutMinutes: 5,
  minCourtDepositPercentage: 20,
  allowFrequentCommercialChanges: false,
  limitOneModelChangePerMonth: true,
  fiscalSettings: DEFAULT_FISCAL_SETTINGS,
};

export function isFrequentCommercialChangesAllowed(): boolean {
  const settings = getSystemSettings();
  return settings.allowFrequentCommercialChanges === true;
}

export const isCommercialChange30DaysBypassEnabled = isFrequentCommercialChangesAllowed;

export function isLimitOneModelChangePerMonthEnabled(): boolean {
  const settings = getSystemSettings();
  if (settings.allowFrequentCommercialChanges === true) {
    return false;
  }
  return settings.limitOneModelChangePerMonth !== false;
}

export function getPendingReservationTimeoutMinutes(): number {
  const settings = getSystemSettings();
  return Number(settings.pendingReservationTimeoutMinutes) || DEFAULT_PENDING_RESERVATION_TIMEOUT_MINUTES;
}

export function getMinCourtDepositPercentage(): number {
  const settings = getSystemSettings();
  return Math.max(DEFAULT_MIN_COURT_DEPOSIT_PERCENTAGE, Number(settings.minCourtDepositPercentage) || DEFAULT_MIN_COURT_DEPOSIT_PERCENTAGE);
}

export function getDefaultArenaFinancialModel(): "SPLIT" | "FIXED_MONTHLY" | "HYBRID" {
  const settings = getSystemSettings();
  return settings.defaultArenaFinancialModel || DEFAULT_ARENA_FINANCIAL_MODEL;
}

export function getFixedMonthlyFee(): number {
  const settings = getSystemSettings();
  return typeof settings.fixedMonthlyFee === "number" ? settings.fixedMonthlyFee : DEFAULT_FIXED_MONTHLY_FEE;
}

export function getFixedMonthlyBillingDays(): number {
  const settings = getSystemSettings();
  return typeof settings.fixedMonthlyBillingDays === "number"
    ? settings.fixedMonthlyBillingDays
    : (typeof settings.monthlyBillingDays === "number" ? settings.monthlyBillingDays : 30);
}

export function getFixedMonthlyDueDays(): number {
  const settings = getSystemSettings();
  return typeof settings.fixedMonthlyDueDays === "number"
    ? settings.fixedMonthlyDueDays
    : (typeof settings.monthlyBillingPaymentDueDateDays === "number" ? settings.monthlyBillingPaymentDueDateDays : 4);
}

export function getHybridMonthlyFee(): number {
  const settings = getSystemSettings();
  return typeof settings.hybridMonthlyFee === "number" ? settings.hybridMonthlyFee : DEFAULT_HYBRID_MONTHLY_FEE;
}

export function getHybridBillingDays(): number {
  const settings = getSystemSettings();
  return typeof settings.hybridBillingDays === "number"
    ? settings.hybridBillingDays
    : (typeof settings.monthlyBillingDays === "number" ? settings.monthlyBillingDays : 30);
}

export function getHybridDueDays(): number {
  const settings = getSystemSettings();
  return typeof settings.hybridDueDays === "number"
    ? settings.hybridDueDays
    : (typeof settings.monthlyBillingPaymentDueDateDays === "number" ? settings.monthlyBillingPaymentDueDateDays : 4);
}

export function getHybridCommissionRate(): number {
  const settings = getSystemSettings();
  const rate = typeof settings.hybridCommissionRate === "number" ? settings.hybridCommissionRate : DEFAULT_HYBRID_COMMISSION_RATE;
  return Math.max(MIN_HYBRID_COMMISSION_RATE, rate);
}

export function getGatewayFeeFixed(): number {
  const settings = getSystemSettings();
  if (typeof settings.gatewayFeeFixed === "number" && !isNaN(settings.gatewayFeeFixed) && settings.gatewayFeeFixed >= 0) {
    return settings.gatewayFeeFixed;
  }
  return 0.99;
}

export function getPlatformCommissionRate(): number {
  const settings = getSystemSettings();
  return Number(settings.platformCommissionRate) || DEFAULT_COMMISSION_RATE;
}

export function getPlatformCommissionFraction(): number {
  return getPlatformCommissionRate() / 100;
}

export function setPlatformCommissionRate(rate: number): void {
  saveSystemSettings({ platformCommissionRate: rate });
}

/**
 * Retorna a taxa oficial da plataforma para inscrições de torneio (%)
 * Administrada pelo Super Admin.
 */
export function getTournamentCommissionRate(): number {
  const settings = getSystemSettings();
  return typeof settings.tournamentCommissionRate === "number"
    ? settings.tournamentCommissionRate
    : Number(settings.platformCommissionRate) || DEFAULT_COMMISSION_RATE;
}

export function getTournamentCommissionFraction(): number {
  return getTournamentCommissionRate() / 100;
}

/**
 * Verifica se a cobrança da taxa da plataforma de torneios está habilitada pelo Super Admin.
 */
export function isTournamentCommissionEnabled(): boolean {
  const settings = getSystemSettings();
  return settings.tournamentCommissionEnabled !== false;
}

/**
 * Verifica se o Super Admin permite a criação de torneios gratuitos (R$ 0,00).
 */
export function isFreeTournamentAllowed(): boolean {
  const settings = getSystemSettings();
  return settings.allowFreeTournaments !== false;
}

/**
 * Retorna a taxa efetiva da plataforma aplicável a torneios (0% se desabilitada).
 */
export function getEffectiveTournamentCommissionRate(): number {
  if (!isTournamentCommissionEnabled()) {
    return 0;
  }
  return getTournamentCommissionRate();
}

/**
 * Retorna a taxa oficial da plataforma para Day Use (%)
 * Administrada pelo Super Admin de forma independente de ingressos.
 */
export function getDayUseCommissionRate(): number {
  const settings = getSystemSettings();
  return typeof settings.dayUseCommissionRate === "number"
    ? settings.dayUseCommissionRate
    : 5.0;
}

export function setDayUseCommissionRate(rate: number): void {
  saveSystemSettings({ dayUseCommissionRate: rate });
}

export function applyRemoteSettings(remoteSettings: any) {
  if (remoteSettings && typeof remoteSettings === "object") {
    saveSystemSettings(remoteSettings);
  }
}

export function isValidTournamentCourtRentalCommissionRate(rate: any): boolean {
  return typeof rate === "number" && ALLOWED_TOURNAMENT_COURT_RENTAL_COMMISSION_RATES.includes(rate);
}

export function resolveTournamentCourtRentalCommissionRate(settings?: Partial<SystemSettings>): number {
  const currentSettings = settings ? { ...getSystemSettings(), ...settings } : getSystemSettings();
  const rate = currentSettings.tournamentCourtRentalCommissionRate;
  if (isValidTournamentCourtRentalCommissionRate(rate)) {
    return rate;
  }
  return DEFAULT_TOURNAMENT_COURT_RENTAL_COMMISSION_RATE;
}

export function resolveTournamentCourtRentalCommissionMode(settings?: Partial<SystemSettings>): "ADD" | "ABSORB" {
  const currentSettings = settings ? { ...getSystemSettings(), ...settings } : getSystemSettings();
  const mode = currentSettings.tournamentCourtRentalCommissionMode;
  if (mode === "ADD" || mode === "ABSORB") {
    return mode;
  }
  return DEFAULT_TOURNAMENT_COURT_RENTAL_COMMISSION_MODE;
}

export function calculateTournamentCourtRentalFinancials(
  rentalAmount: number,
  overrideRate?: number,
  overrideMode?: "ADD" | "ABSORB"
): TournamentCourtRentalFinancials {
  const baseRental = Math.max(0, Number(rentalAmount) || 0);
  const rate = isValidTournamentCourtRentalCommissionRate(overrideRate)
    ? (overrideRate as number)
    : resolveTournamentCourtRentalCommissionRate();
  const mode = (overrideMode === "ADD" || overrideMode === "ABSORB")
    ? overrideMode
    : resolveTournamentCourtRentalCommissionMode();

  const platformFeeAmount = Number(((baseRental * rate) / 100).toFixed(2));

  let organizerTotalToPay = baseRental;
  let arenaNetAmount = baseRental;

  if (mode === "ADD") {
    organizerTotalToPay = Number((baseRental + platformFeeAmount).toFixed(2));
    arenaNetAmount = baseRental;
  } else {
    organizerTotalToPay = baseRental;
    arenaNetAmount = Number(Math.max(0, baseRental - platformFeeAmount).toFixed(2));
  }

  return {
    rentalAmount: baseRental,
    commissionRate: rate,
    commissionMode: mode,
    platformFeeAmount,
    arenaNetAmount,
    organizerTotalToPay,
  };
}

/**
 * Sanitização defensiva e expurgo de qualquer chave ou token de API
 * antes de qualquer persistência no localStorage ou Firestore.
 */
export function sanitizeSystemSettingsForPersistence(settings: any): SystemSettings {
  const clean = { ...settings };

  // Expurgar campos de segredos em texto aberto caso venham de versões legadas
  delete clean.asaasKey;
  delete clean.asaasSandboxApiKey;
  delete clean.asaasProductionApiKey;
  delete clean.asaasSandboxWebhookToken;
  delete clean.asaasProductionWebhookToken;
  delete clean.asaasWebhookToken;

  return clean as SystemSettings;
}

// Cache em memória para configurações autoritativas (Firestore tem precedência absoluta sobre LocalStorage)
const localSettingsListeners = new Set<(settings: SystemSettings) => void>();

function notifyLocalSettingsListeners(settings: SystemSettings) {
  localSettingsListeners.forEach((cb) => {
    try { cb(settings); } catch (e) { console.error(e); }
  });
}

let authoritativeSystemSettings: SystemSettings | null = null;

/**
 * Define ou limpa as configurações autoritativas em memória (usado para injeção de Firestore e testes)
 */
export function setAuthoritativeSystemSettings(settings: Partial<SystemSettings> | null): SystemSettings {
  if (!settings) {
    authoritativeSystemSettings = null;
    const def = getSystemSettings();
    notifyLocalSettingsListeners(def);
    return def;
  }
  const sanitized = sanitizeSystemSettingsForPersistence(settings);
  const current = authoritativeSystemSettings || DEFAULT_SYSTEM_SETTINGS;
  const merged: SystemSettings = { ...DEFAULT_SYSTEM_SETTINGS, ...current, ...sanitized };
  authoritativeSystemSettings = merged;
  StorageService.set(STORAGE_KEYS.SYSTEM_SETTINGS, merged);
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("system_settings_updated", { detail: merged }));
  }
  notifyLocalSettingsListeners(merged);
  return merged;
}

export function getSystemSettings(): SystemSettings {
  if (authoritativeSystemSettings) {
    return { ...DEFAULT_SYSTEM_SETTINGS, ...authoritativeSystemSettings };
  }
  try {
    const saved = StorageService.get<Partial<SystemSettings>>(STORAGE_KEYS.SYSTEM_SETTINGS, null);
    if (saved) {
      const sanitized = sanitizeSystemSettingsForPersistence(saved);
      const merged: SystemSettings = { ...DEFAULT_SYSTEM_SETTINGS, ...sanitized };
      if (!merged.gatewayFeePayer && merged.whoPaysMpFee) {
        merged.gatewayFeePayer = merged.whoPaysMpFee === "arena" ? "ARENA" : "PLATFORM";
      } else if (merged.gatewayFeePayer && !merged.whoPaysMpFee) {
        merged.whoPaysMpFee = merged.gatewayFeePayer === "ARENA" ? "arena" : "platform";
      }
      if (merged.courtCommissionRate !== undefined && merged.platformCommissionRate === undefined) {
        merged.platformCommissionRate = merged.courtCommissionRate;
      } else if (merged.platformCommissionRate !== undefined && merged.courtCommissionRate === undefined) {
        merged.courtCommissionRate = merged.platformCommissionRate;
      }
      return merged;
    }
  } catch (err) {
    console.error("Error reading system settings", err);
  }
  return DEFAULT_SYSTEM_SETTINGS;
}

export function saveSystemSettings(settings: Partial<SystemSettings>): SystemSettings {
  try {
    const current = getSystemSettings();
    const sanitizedInput = sanitizeSystemSettingsForPersistence(settings);

    if (sanitizedInput.tournamentCourtRentalCommissionRate !== undefined) {
      if (!isValidTournamentCourtRentalCommissionRate(sanitizedInput.tournamentCourtRentalCommissionRate)) {
        sanitizedInput.tournamentCourtRentalCommissionRate = DEFAULT_TOURNAMENT_COURT_RENTAL_COMMISSION_RATE;
      }
    }

    if (sanitizedInput.gatewayFeeFixed !== undefined) {
      sanitizedInput.gatewayFeeFixed = Math.max(0, Number(sanitizedInput.gatewayFeeFixed) ?? 0.99);
    }

    if (sanitizedInput.minCourtDepositPercentage !== undefined) {
      sanitizedInput.minCourtDepositPercentage = Math.max(
        DEFAULT_MIN_COURT_DEPOSIT_PERCENTAGE,
        Number(sanitizedInput.minCourtDepositPercentage) || DEFAULT_MIN_COURT_DEPOSIT_PERCENTAGE
      );
    }

    if (sanitizedInput.pendingReservationTimeoutMinutes !== undefined) {
      sanitizedInput.pendingReservationTimeoutMinutes = Math.max(
        1,
        Math.min(1440, Number(sanitizedInput.pendingReservationTimeoutMinutes) || DEFAULT_PENDING_RESERVATION_TIMEOUT_MINUTES)
      );
    }

    if (sanitizedInput.fixedMonthlyFee !== undefined) {
      sanitizedInput.fixedMonthlyFee = Math.max(0, Number(sanitizedInput.fixedMonthlyFee) || DEFAULT_FIXED_MONTHLY_FEE);
    }

    if (sanitizedInput.hybridMonthlyFee !== undefined) {
      sanitizedInput.hybridMonthlyFee = Math.max(0, Number(sanitizedInput.hybridMonthlyFee) || DEFAULT_HYBRID_MONTHLY_FEE);
    }

    // Regra Crítica: HYBRID NÃO PODE SER TRANSFORMADO EM FIXED_MONTHLY através de comissão 0%
    if (sanitizedInput.hybridCommissionRate !== undefined) {
      const parsedRate = Number(sanitizedInput.hybridCommissionRate);
      if (isNaN(parsedRate) || parsedRate <= 0) {
        sanitizedInput.hybridCommissionRate = DEFAULT_HYBRID_COMMISSION_RATE;
      } else {
        sanitizedInput.hybridCommissionRate = Math.max(MIN_HYBRID_COMMISSION_RATE, parsedRate);
      }
    }

    const updated = { ...current, ...sanitizedInput };

    // CANONICAL FIELD CONSOLIDATION:
    // 1. courtCommissionRate é o campo canônico para taxa percentual de comissão de reservas de quadra.
    // platformCommissionRate é mantido em sincronia estrita como legado para compatibilidade de consumidores antigos.
    if (sanitizedInput.platformCommissionRate !== undefined && sanitizedInput.platformCommissionRate !== current.platformCommissionRate) {
      const canonicalRate = Number(sanitizedInput.platformCommissionRate) || 0;
      updated.courtCommissionRate = canonicalRate;
      updated.platformCommissionRate = canonicalRate;
    } else if (sanitizedInput.courtCommissionRate !== undefined) {
      const canonicalRate = Number(sanitizedInput.courtCommissionRate) || 0;
      updated.courtCommissionRate = canonicalRate;
      updated.platformCommissionRate = canonicalRate;
    } else if (sanitizedInput.platformCommissionRate !== undefined) {
      const canonicalRate = Number(sanitizedInput.platformCommissionRate) || 0;
      updated.courtCommissionRate = canonicalRate;
      updated.platformCommissionRate = canonicalRate;
    }

    // 2. gatewayFeePayer ("PLATFORM" | "ARENA") é o campo canônico para custódia da taxa de gateway.
    // whoPaysMpFee ("platform" | "arena") é mantido em sincronia estrita como legado.
    if (sanitizedInput.whoPaysMpFee !== undefined && sanitizedInput.whoPaysMpFee !== current.whoPaysMpFee) {
      updated.whoPaysMpFee = sanitizedInput.whoPaysMpFee;
      updated.gatewayFeePayer = sanitizedInput.whoPaysMpFee === "arena" ? "ARENA" : "PLATFORM";
    } else if (sanitizedInput.gatewayFeePayer !== undefined) {
      updated.gatewayFeePayer = sanitizedInput.gatewayFeePayer;
      updated.whoPaysMpFee = sanitizedInput.gatewayFeePayer === "ARENA" ? "arena" : "platform";
    } else if (sanitizedInput.whoPaysMpFee !== undefined) {
      updated.gatewayFeePayer = sanitizedInput.whoPaysMpFee === "arena" ? "ARENA" : "PLATFORM";
      updated.whoPaysMpFee = sanitizedInput.whoPaysMpFee;
    }

    // Se o modelo for HYBRID, assegura que a taxa é estritamente transacional (> 0%)
    if (updated.defaultArenaFinancialModel === "HYBRID") {
      if (!updated.hybridCommissionRate || updated.hybridCommissionRate <= 0) {
        updated.hybridCommissionRate = DEFAULT_HYBRID_COMMISSION_RATE;
      }
    }
    const cleanToStore = sanitizeSystemSettingsForPersistence(updated);

    authoritativeSystemSettings = cleanToStore;
    StorageService.set(STORAGE_KEYS.SYSTEM_SETTINGS, cleanToStore);

    if (settings.platformCommissionRate !== undefined) {
      StorageService.setRaw(STORAGE_KEYS.COMMISSION_RATE, settings.platformCommissionRate.toString());
    }
    if (settings.platformFixedFee !== undefined) {
      StorageService.setRaw(STORAGE_KEYS.FIXED_FEE, settings.platformFixedFee.toString());
    }
    if (settings.feeDeductionMode !== undefined) {
      StorageService.setRaw(STORAGE_KEYS.FEE_MODE, settings.feeDeductionMode);
    }

    // Sincroniza assincronamente com o Firestore com dados estritamente sanitizados (sem secrets)
    saveSystemSettingsFirestore(cleanToStore).catch((err) => {
      console.error("Erro ao salvar system_settings no Firestore:", err);
    });

    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("system_settings_updated", { detail: cleanToStore }));
    }
    notifyLocalSettingsListeners(cleanToStore);
    return cleanToStore;
  } catch (err) {
    console.error("Error saving system settings", err);
    return getSystemSettings();
  }
}

export function loadAndSubscribeSystemSettings(callback?: (settings: SystemSettings) => void): () => void {
  const current = getSystemSettings();
  if (callback) {
    localSettingsListeners.add(callback);
    callback(current);
  }

  const handleLocalUpdate = (e: any) => {
    const updated = e?.detail || getSystemSettings();
    if (callback) callback(updated);
  };

  if (typeof window !== "undefined") {
    window.addEventListener("system_settings_updated", handleLocalUpdate);
  }

  loadSystemSettingsFirestore()
    .then((firestoreSettings) => {
      if (firestoreSettings) {
        const sanitized = sanitizeSystemSettingsForPersistence(firestoreSettings);
        const merged: SystemSettings = { ...DEFAULT_SYSTEM_SETTINGS, ...getSystemSettings(), ...sanitized };
        authoritativeSystemSettings = merged;
        StorageService.set(STORAGE_KEYS.SYSTEM_SETTINGS, merged);
        if (callback) callback(merged);
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent("system_settings_updated", { detail: merged }));
        }
      }
    })
    .catch((err) => {
      console.error("Erro ao carregar system_settings do Firestore:", err);
    });

  const unsubFirestore = subscribeSystemSettingsFirestore((firestoreSettings) => {
    if (firestoreSettings) {
      const sanitized = sanitizeSystemSettingsForPersistence(firestoreSettings);
      const merged: SystemSettings = { ...DEFAULT_SYSTEM_SETTINGS, ...getSystemSettings(), ...sanitized };
      authoritativeSystemSettings = merged;
      StorageService.set(STORAGE_KEYS.SYSTEM_SETTINGS, merged);
      if (callback) callback(merged);
      if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent("system_settings_updated", { detail: merged }));
      }
    }
  });

  return () => {
    if (callback) {
      localSettingsListeners.delete(callback);
    }
    if (typeof window !== "undefined") {
      window.removeEventListener("system_settings_updated", handleLocalUpdate);
    }
    if (typeof unsubFirestore === "function") {
      unsubFirestore();
    }
  };
}
